import { convertValuesToHandles, updateUrl } from "./utils.js";

class UtmSwatchCarousel extends HTMLElement {
  connectedCallback() {
    this.initializeElements();
    this.initializeListeners();
    this.render();
  }

  initializeElements() {
    this.productWrapper = document.querySelector(".product-wrapper");
    this.allSwatchProductCardsInThisFabric = Array.from(
      this.querySelectorAll(".utm-swatch"),
    );
    this.carouselContainer = this.querySelector(
      "#utm-swatch-carousel-container",
    );
    this.variantColors = this.productWrapper.querySelector("variant-colors");
    this.colorInputs = Array.from(this.variantColors.querySelectorAll("input"));
    this.startingIndex = this.colorInputs.findIndex((input) => input.checked);
    this.productState = document.querySelector("product-state");
    this.fabric = this.productState.getAttribute("fabric-handleized");
  }

  /**
   * Update the url history in the window.
   *
   * This is needed when a color or fabric selector causes a re-render.
   *
   * We need the URL to update before the next call so we stop rendering.
   */
  initializeListeners() {
    this.productWrapper
      .querySelectorAll(".color-label, .fabric-label")
      .forEach((label) => {
        label.addEventListener("click", () => {
          updateUrl("products", label.dataset.product);
          this.updateCarousel();
        });
      });
  }

  updateCarousel = () => {
    /**
     * Get the url param for utm_source.
     *
     * If it doesn't exist or doesn't equal google, remove this component from the DOM.
     */
    const allParams = new URLSearchParams(window.location.search);
    const utmSourceparam = allParams.get("utm_source");
    if (utmSourceparam !== "google") {
      this.remove();
      return;
    }
    const colorValues = [];
    /**
     * Set the amount of swatch products to appear in the carousel.
     */
    const numberOfSwatchesInCarousel = 8;
    /**
     * Count the iterations since our loop may need to reset it's idx back to 0.
     */
    let iterationCount = 0;
    /**
     * Get color values to use in handles
     *
     * Loop wraps back to the first indice if there aren't enough colors from where the iteration started.
     */
    for (
      let idx = this.startingIndex;
      iterationCount < numberOfSwatchesInCarousel;
      idx += 1
    ) {
      if (idx >= this.colorInputs.length) idx = 0;
      const currentColor = this.colorInputs[idx];
      const colorValue = currentColor.value;
      colorValues.push(colorValue);
      iterationCount += 1;
    }

    const colorHandles = convertValuesToHandles(colorValues);

    /**
     * Use fabric and color to generate swatch handles.
     *
     * Example format: swatch-chiffon-in-dusty-blue
     */
    const swatchHandles = colorHandles.map(
      (color) => `swatch-${this.fabric}-in-${color}`,
    );

    /**
     * Map the product cards by handle
     */
    const productCardMap = new Map(
      this.allSwatchProductCardsInThisFabric.map((card) => [
        card.dataset.handle,
        card,
      ]),
    );

    /**
     * Create an array of only the relevant swatches in order
     */
    const swatchProductCardsInOrder = swatchHandles.reduce((acc, handle) => {
      const card = productCardMap.get(handle);
      if (card) {
        acc.push(card);
      }
      return acc;
    }, []);

    /**
     * Remove all current swatch products from carousel.
     */
    this.carouselContainer.innerHTML = ``;

    /**
     * Add the ordered swatch products into the carousel and display.
     */
    swatchProductCardsInOrder.forEach((card) => {
      this.carouselContainer.appendChild(card);
    });
  };

  render() {
    this.updateCarousel();
  }
}

export default UtmSwatchCarousel;
